import QuizModalBody from './QuizModalBody';

export default QuizModalBody;
